import type { IconData } from '@stacksjs/iconify-core'

export const sendEmail: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18.29 6.1v1.52h-1.52v3.05h1.52V9.14h1.52V7.62h10.67v1.52h-1.52v1.53h1.52v1.52H32V6.1zm10.67 6.09h1.52v3.05h-1.52Zm-1.53 4.57H15.24v-1.52h-1.52v3.05h15.24v-3.05h-1.53z\"/><path fill=\"currentColor\" d=\"M27.43 10.67h1.53v1.52h-1.53Zm-1.52-7.62h1.52v1.52h-1.52ZM1.53 19.81V3.05H0v21.33h1.53v1.53h7.62v1.52h1.52v-1.52h6.1v1.52h1.52v-1.52h7.62v-1.53h1.52v-4.57zm21.33-7.62h4.57v1.53h-4.57Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.53-1.53h1.53v1.53h-1.53ZM9.15 28.95v-1.52H7.62v3.05h12.19v-3.05h-1.52v1.52z\"/><path fill=\"currentColor\" d=\"M15.24 10.67h1.53v4.57h-1.53Zm-6.09 0h4.57v1.52H9.15Zm-1.53 3.05h4.57v1.52H7.62Zm0-6.1h4.57v1.52H7.62ZM6.1 10.67h1.52v1.52H6.1Zm-1.53 3.05H6.1v1.52H4.57Zm0-6.1H6.1v1.52H4.57Zm-3.04-6.1h24.38v1.53H1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default sendEmail
